import { GetConnection } from './NotificationHub';
import { NotificationStatus } from './data';
import { NotificationData, NotificationsDispatch } from './notifications-types';

export const NOTIFICATIONCENTER_TEMPLATECOPIED = 'NOTIFICATIONCENTER_TEMPLATECOPIED';
export const NOTIFICATIONCENTER_UPDATE = 'NOTIFICATIONCENTER_UPDATE';
export const NOTIFICATIONCENTER_DELETE = 'NOTIFICATIONCENTER_DELETE';
export const NOTIFICATION_DELETE_MODAL_OPEN = 'NOTIFICATION_DELETE_MODAL_OPEN';
export const NOTIFICATIONCENTER_OPEN = 'NOTIFICATIONCENTER_OPEN';
export const NOTIFICATIONCENTER_LOADING = 'NOTIFICATIONCENTER_LOADING';
export const NOTIFICATIONCENTER_PDSNOTIFICATIONCOMPLETED = 'NOTIFICATIONCENTER_PDSNOTIFICATIONCOMPLETED';

export const setDeleteModalOpen = (isOpen: boolean) => {
  return {
    type: NOTIFICATION_DELETE_MODAL_OPEN,
    payload: { deleteModalOpen: isOpen }
  };
};

export const updateNotifications = (notifications: Partial<NotificationData>[]) => {
  return {
    type: NOTIFICATIONCENTER_UPDATE,
    payload: { notifications }
  };
};

export const deleteNotifications = (notifications: NotificationData[]) => {
  return {
    type: NOTIFICATIONCENTER_DELETE,
    payload: { notifications }
  };
};

export const templateCopied = () => {
  return {
    type: NOTIFICATIONCENTER_TEMPLATECOPIED
  };
};

export const pdsNotificationCompleted = (isCompleted: boolean) => {
  return {
    type: NOTIFICATIONCENTER_PDSNOTIFICATIONCOMPLETED,
    payload: { hasCompletedPdsNotification: isCompleted }
  };
};

export const openNotificationCenter = (isOpen: boolean) => {
  return {
    type: NOTIFICATIONCENTER_OPEN,
    payload: { notificationCenterOpen: isOpen }
  };
};

export const loadingNotifications = (isLoading: boolean) => {
  return {
    type: NOTIFICATIONCENTER_LOADING,
    payload: { isLoading }
  };
};

//Action Creators

export async function markAsRead(notificationDataList: NotificationData[], dispatch: NotificationsDispatch) {
  const unreadNotifications = notificationDataList.filter((x) => !x.read);
  if (unreadNotifications?.length === 0) {
    return;
  }

  try {
    dispatch(loadingNotifications(true));
    await GetConnection().invoke(
      'MarkRead',
      unreadNotifications.map((x) => x.id)
    );

    const updatedNotifications = unreadNotifications.map((notification) => ({
      ...notification,
      read: true
    }));
    dispatch(updateNotifications(updatedNotifications));
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(loadingNotifications(false));
  }
}

export async function markAsUnread(notificationDataList: NotificationData[], dispatch: NotificationsDispatch) {
  const readNotifications = notificationDataList.filter((x) => x.read);

  if (readNotifications?.length === 0) {
    return;
  }

  try {
    dispatch(loadingNotifications(true));
    await GetConnection().invoke(
      'MarkUnread',
      readNotifications.map((x) => x.id)
    );

    const updatedNotifications = readNotifications.map((notification) => ({
      ...notification,
      read: false
    }));
    dispatch(updateNotifications(updatedNotifications));
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(loadingNotifications(false));
  }
}

export async function markForDelete(notificationDataList: NotificationData[], dispatch: NotificationsDispatch) {
  if (notificationDataList?.length === 0) {
    return;
  }

  try {
    dispatch(loadingNotifications(true));
    await GetConnection().invoke(
      'Delete',
      notificationDataList.map((x) => x.id)
    );

    dispatch(deleteNotifications(notificationDataList));
    dispatch(setDeleteModalOpen(false));
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(loadingNotifications(false));
  }
}

export function addPendingNotification(notification: Partial<NotificationData>, dispatch: NotificationsDispatch) {
  const queuedNotification = {
    ...notification,
    timestamp: new Date(),
    createdDate: new Date(),
    status: NotificationStatus.Queued
  };

  dispatch(updateNotifications([queuedNotification]));
  dispatch(openNotificationCenter(true));
}

export function updatePendingNotification(notification: Partial<NotificationData>, dispatch: NotificationsDispatch) {
  const updatedNotification = {
    ...notification,
    timestamp: new Date(),
    status: notification.status || NotificationStatus.Queued,
    read: notification.read || false
  };

  dispatch(updateNotifications([updatedNotification]));
}
